import React, {useContext, useState} from 'react'
import ReadingGroupsPage from './ReadingGroupsContext'
import ReadingGroups from './ReadingGroups'
import {Switch} from 'components/Form'
import { AssessmentsContext } from 'pages/School/Assessments/AssessmentsContext'

// const TOOLBAR_TEXT_COMBINED = <>כעת דירוגי <b>"גבוה"</b> ו<b>"מצופה"</b> מוצגים יחד לצורך תצוגה פשוטה וברורה יותר. ניתן ללחוץ על המתג כדי לפרק את האיחוד ולהציג כל דירוג בנפרד.</>
// const TOOLBAR_TEXT_SPLIT = <>כעת דירוגי <b>"גבוה"</b> ו<b>"מצופה"</b> מוצגים בנפרד. ניתן ללחוץ על המתג לאיחוד הדירוגים לתצוגה פשוטה יותר.</>
const TOOLBAR_TEXT_TITLE_ON = " התלמידים מוצגים לפי כל הדירוגים. לצורך בהירות אפשר ללחוץ על המתג ולאחד בין דירוג “גבוה” לבין דירוג “הטווח המצופה”.";
// const TOOLBAR_TEXT_TITLE_ON = "כעת דירוגי \"גבוה\" ו\"מצופה\" מוצגים יחד לצורך תצוגה פשוטה וברורה יותר.";
const TOOLBAR_TEXT_TITLE_OFF =  "דירוגי  הקריאה \"גבוה\" ו\"מצופה\" מוצגים יחד לצורך תצוגה פשוטה יותר. ניתן ללחוץ על המתג כדי לפרק את האיחוד ולהציג כל דירוג בנפרד.";
// const TOOLBAR_TEXT_TITLE_OFF =  "כעת דירוגי \"גבוה\" ו\"מצופה\" מוצגים יחד לצורך תצוגה פשוטה וברורה יותר.";
const TOOLBAR_TEXT_TITLE = (isToggleOn) => isToggleOn ? TOOLBAR_TEXT_TITLE_ON : TOOLBAR_TEXT_TITLE_OFF;

const WrapReadingGroups = () => {
    const { profileFilters: filters, setProfileFilters: setFilters } = useContext(AssessmentsContext)
    const [splitRatings, setSplitRatings] = useState(false)

    return (
        <ReadingGroupsPage
            filters={filters}
            setFilters={setFilters}
            splitRatings={splitRatings}
            title={(count) => `מוצגים ${count} תלמידים בחלוקה לפי שילובים דומים של ביצועי קצב ודיוק בקריאה.`}
            // title="מצב התלמידים בחלוקה לקבוצות קריאה"
            subTitle="כאן מוצגת תמונת מצב כיתתית לפי ביצועי הקריאה של התלמידים. החלוקה לקבוצות עוזרת לזהות דפוסים, לאתר תלמידים הזקוקים לחיזוק ולתכנן הוראה מותאמת."
            toolbarTextTitle={TOOLBAR_TEXT_TITLE(splitRatings)}
            // toolbarTextSubTitle={TOOLBAR_TEXT_SUB_TITLE(splitRatings)}
            customToolbar={
                <div className='view-options-btns'>
                    <Switch
                        label="פרוק הדירוגים לגבוה ומצופה"
                        input={{
                            value: splitRatings,
                            onChange: setSplitRatings
                        }}
                    />
                </div>
            }
        >
            <ReadingGroups/>
        </ReadingGroupsPage>
    )
}

export default WrapReadingGroups
